import animateValue, { updateHeight } from "../utils/animateValue";

export default function(el) {
    const opener = el.querySelector(".expandable__opener");
    const content = el.querySelector(".expandable__content");
    const childExpandables = content ? content.querySelectorAll(".expandable__content") : [];
    let expandedByDefault = el.classList.contains("expandable--expanded");
    let opened = expandedByDefault;

    const getChildrenHeight = () => {
        let childrenHeight = content.scrollHeight;

        for (const child of childExpandables) {
            childrenHeight += child.offsetHeight;
        }

        return childrenHeight;
    };

    const changeState = () => {
        opened = !opened;
        const actionType = opened ? "add" : "remove";

        const maxHeight = !opened ? 0 : childExpandables.length ? getChildrenHeight() : content.scrollHeight;

        animateValue(content, updateHeight, content.offsetHeight, maxHeight, 250);

        if (expandedByDefault) el.classList.remove("expandable--expanded");

        el.classList[actionType]("expandable--active");
    };

    if (!opener || !content) return;

    opener.addEventListener("click", changeState);
}
